import { z } from 'zod'

export const PHOTO_MAX_BYTES = 256 * 1024
export const PHOTO_MAX_EDGE = 768
export const photoResultSchema = z.strictObject({
  names: z.array(z.string().trim().min(1).max(40).regex(/^[\p{L}\p{N}（）()·、\s-]+$/u)).max(10),
})
export type FoodPhotoResult = z.infer<typeof photoResultSchema>
export interface FoodPhotoRecognizer {
  recognize(image: Blob, signal: AbortSignal): Promise<FoodPhotoResult>
}

// Treat all model output as untrusted suggestions, never as nutrition or executable instructions.
export function parseFoodPhotoOutput(output: unknown): FoodPhotoResult {
  if (typeof output === 'object' && output !== null) {
    const result = photoResultSchema.parse(output)
    return { names: [...new Set(result.names)] }
  }
  if (typeof output !== 'string' || output.length > 2048) throw new Error('无法识别结果')
  // Some live responses wrap JSON in prose. Discard prose and validate the sole object.
  const first = output.indexOf('{'); const last = output.lastIndexOf('}')
  const text = first >= 0 && last >= first ? output.slice(first, last + 1) : output
  const result = photoResultSchema.parse(JSON.parse(text))
  return { names: [...new Set(result.names)] }
}
